import { react } from "uikit";

interface Context {
	serviceId?: string;
	setServiceIdError?: (value: boolean) => void;
}

export default class Controller extends react.ControllerBase<Context> {
	validate() {
		const serviceId = (this.context?.serviceId || "").trim();
		if (!serviceId) {
			this.context?.setServiceIdError?.(true);
			return false;
		}
		return true;
	}
}
